<template>
  <div class="mypage-ticket-today-current-time-parts">
    <svg
      class="mypage-ticket-today-current-time-parts__bg mypage-ticket-today-current-time-parts__bg--left"
      width="53"
      height="50"
      viewBox="0 0 53 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3956_16647)">
        <path
          d="M-14 -1.90511e-05L36.8013 44.1202C41.1673 47.912 46.7556 50 52.5384 50L53 49.9999V-6.10352e-05L-14 -1.90511e-05Z"
          fill="url(#paint0_linear_3956_16647)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3956_16647"
          x1="19.5"
          y1="50"
          x2="19.5"
          y2="-6.10352e-05"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stop-opacity="0.5" />
        </linearGradient>
        <clipPath id="clip0_3956_16647">
          <rect width="67" height="50" fill="white" transform="translate(-14)" />
        </clipPath>
      </defs>
    </svg>
    <svg
      class="mypage-ticket-today-current-time-parts__bg mypage-ticket-today-current-time-parts__bg--right"
      width="53"
      height="50"
      viewBox="0 0 53 50"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_3956_16650)">
        <path
          d="M67 -1.90511e-05L16.1987 44.1202C11.8327 47.912 6.24438 50 0.461601 50L0 49.9999V-6.10352e-05L67 -1.90511e-05Z"
          fill="url(#paint0_linear_3956_16650)"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_3956_16650"
          x1="33.5"
          y1="50"
          x2="33.5"
          y2="-6.10352e-05"
          gradientUnits="userSpaceOnUse"
        >
          <stop />
          <stop offset="1" stop-opacity="0.5" />
        </linearGradient>
        <clipPath id="clip0_3956_16650">
          <rect width="67" height="50" fill="white" transform="matrix(-1 0 0 1 67 0)" />
        </clipPath>
      </defs>
    </svg>
    <div
      class="mypage-ticket-today-current-time-parts__bg mypage-ticket-today-current-time-parts__bg--center"
    ></div>

    <p class="mypage-ticket-today-current-time-parts__time" v-text="currentTime" />
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, onUnmounted } from '@vue/composition-api'
import dayjs from 'dayjs'
import useDisplayDependingOnLang from '@/components/hook/useDisplayDependingOnLang'

/**
 * マイページ: 本日のチケット現在時刻表示パーツ
 */
export default defineComponent({
  name: 'MypageTicketTodayCurrentTimeParts',
  setup() {
    const { getDisplayDate } = useDisplayDependingOnLang()

    /**
     * 現在時刻を取得
     * dayjs使用 YYYY/MM/DD hh:mm:ss 形式
     * @returns 現在時刻
     */
    const getCurrentTime = () =>
      getDisplayDate(dayjs().valueOf(), 'YYYY/MM/DD HH:mm:ss', 'MMM DD, YYYY HH:mm:ss')
    const currentTime = ref<string>(getCurrentTime())

    let currentTimeTimer: number

    onMounted(() => {
      currentTime.value = getCurrentTime()

      currentTimeTimer = window.setInterval(() => {
        currentTime.value = getCurrentTime()
      }, 1000)
    })

    onUnmounted(() => {
      clearInterval(currentTimeTimer)
    })

    return {
      currentTime,
    }
  },
})
</script>

<style lang="scss" scoped>
.mypage-ticket-today-current-time-parts {
  position: relative;
  padding: 22px 0 8px;
  width: 100%;
  text-align: center;
  color: $white;

  &__bg {
    position: absolute;
    z-index: -1;
    top: 0;
    height: 50px;
    overflow: visible;

    &--left {
      width: 53px;
      left: 0;
    }

    &--right {
      width: 53px;
      right: 0;
    }

    &--center {
      left: 53px;
      width: calc(100% - 106px);
      background: linear-gradient(0deg, #000000 0%, rgba(0, 0, 0, 0.5) 100%);
    }
  }

  &__time {
    font-family: $fontTelemetrySpeedGear;
    font-size: 20px;
    font-style: normal;
    font-weight: 500;
    line-height: 1;
    letter-spacing: 0.04em;
  }
}
</style>
